module.exports = __webpack_public_path__ + "img/survey-intro.4add01b.svg";